export const INIT_APP = 'INIT_APP'
export const ADD_APP = 'ADD_APP'
export const UPDATE_APP = 'UPDATE_APP'
export const REMOVE_APP = 'REMOVE_APP'
